import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import * as authHelper from '../app/modules/auth/core/AuthHelpers'
import {refreshBaseQuery} from './refreshBaseQuery'

const API_URL = process.env.REACT_APP_API_URL

export const referServiceApi = createApi({
  reducerPath: 'referServiceApi',
  baseQuery: refreshBaseQuery,
  endpoints: (builder) => ({
    getReferredUsers: builder.query({
      query: ({id, page}) => ({
        url: `/referral/users/${id}?page=${page}`,
        method: 'GET',
      }),
    }),
    getMembersStat: builder.query({
      query: (id) => ({
        url: `/referral/members-stat/${id}`,
        method: 'GET',
      }),
    }),
  }),
})
export const {useGetReferredUsersQuery, useGetMembersStatQuery} = referServiceApi
